import { reducerWithInitialState } from 'typescript-fsa-reducers';

import { getDefaultNetworkStatus } from '@utils';

import {
	authFetchCurrentReducer,
	authLoginReducer,
	authLogoutReducer,
	zeppUpdateSettingsReducer,
} from './actions';

import { IAuthStore } from './types';

export const getAuthInitialState = (): IAuthStore => ({
	user: {
		data: {
			user: null,
		},
		meta: {
			networkStatus: getDefaultNetworkStatus(),
		},
	},
});

export const auth = reducerWithInitialState<IAuthStore>(getAuthInitialState());

authFetchCurrentReducer(auth);
authLoginReducer(auth);
authLogoutReducer(auth);
zeppUpdateSettingsReducer(auth);
